import React, { useState } from 'react';
import { Modal, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import './VintageModal.scss';

export default function LoginModal({ show, onHide, onSwitchToRegister }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) return setError('Bitte füllen Sie alle Felder aus.');
    setLoading(true);
    try {
      await login(email, password);
      onHide();
    } catch (err) {
      setError(err.message || 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="vintage-modal">
      <Modal.Header closeButton>
        <Modal.Title>Anmelden</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>E-Mail-Adresse</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Passwort</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Button type="submit" className="form-button" disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : 'Anmelden'}
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <span>
          Noch kein Konto?{' '}
          <Button variant="link" onClick={onSwitchToRegister}>
            Jetzt registrieren
          </Button>
        </span>
      </Modal.Footer>
    </Modal>
  );
}
